export const enum CodeError {
  NOT_SEND = 'Не вышло время повторной отправки',
  NOT_TOKEN = 'Код устарел, вышли повторно',
  NOT_CODE = 'Неправильный код',
  SOMETHING_WRONG = 'Что-то пошло не так, попробуй чуть позже',
}

export const enum PhoneError {
  INCORRECT_PHONE = 'Неверный формат телефона',
  INCORRECT_PASSWORD = 'Неверный пароль',
  REQUIRED = 'Обязательное поле',
}
